import { Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { HomeLabelBadge } from './HomeLabelBadge';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles/createTheme';

interface HomeIconLabelProps {
  src: string;
  labelKey: string;
  badgeContent?: string | number;
  labelSxProps?: SxProps<Theme>;
}
export const HomeIconLabel = (props: HomeIconLabelProps) => {
  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      sx={{
        color: '#3b4559',
      }}
    >
      <img
        src={props.src}
        style={{
          width: 30,
          height: 30,
        }}
      />
      <Typography
        sx={{
          ml: 2.5,
          fontWeight: 500,
          ...props.labelSxProps,
        }}
      >
        <FormattedMessage id={props.labelKey} />
      </Typography>
      {props.badgeContent ? (
        <HomeLabelBadge badgeContent={props.badgeContent} />
      ) : null}
    </Stack>
  );
};
